const Loader = () => {
  return (
    <span className="globalLoader"/>
  )
}
export default Loader